import React from 'react'

import { MedicalRecordForm } from 'models/MedicalRecord/MedicalRecordForm.type'

import { ListField } from '../components/ListField'
import { ReadOnlyField } from '../components/ReadOnlyField'
import {
  PATIENT_CASE_COMPLEXITY_COLORS,
  PATIENT_CASE_COMPLEXITY_LABELS,
  PATIENT_CONSUMPTION_LABELS,
  PATIENT_GOAL_LABELS,
  SYMPTOMS_IMPACT_LABELS,
  formatBoolean,
} from '../utils/fieldLabels'
import { formatDiagnosticsList, formatMedicationsList } from '../utils/formatters'

import * as S from '../styles'

interface EvaluationViewProps {
  form: MedicalRecordForm
}

export function EvaluationView({ form }: EvaluationViewProps): JSX.Element {
  const complaintNames = form.complaints?.map((c) => c.complaint?.description).filter(Boolean) ?? []
  const symptomNames = form.symptoms?.map((s) => s.symptom?.description).filter(Boolean) ?? []
  const consumptionLabels =
    form.patient_consumptions
      ?.filter((c) => c !== 'OTHERS')
      .map((c) => PATIENT_CONSUMPTION_LABELS[c] ?? c) ?? []

  return (
    <S.Section>
      <ListField
        label='Queixa do paciente'
        items={complaintNames}
        otherText={form.other_complaint?.description}
      />
      <ListField
        label='Sintomas'
        items={symptomNames}
        otherText={form.other_symptom?.description}
      />
      <ReadOnlyField
        label='Qual o impacto destes sintomas na rotina de trabalho?'
        value={
          form.symptoms_impact_on_work_life &&
          (SYMPTOMS_IMPACT_LABELS[form.symptoms_impact_on_work_life] ?? form.symptoms_impact_on_work_life)
        }
      />
      <ReadOnlyField
        label='Paciente possui ideação suicida?'
        value={formatBoolean(form.has_suicidal_ideation)}
      />
      <ListField
        label='O paciente consome...'
        items={consumptionLabels}
        otherText={form.other_patient_consumption?.description}
      />
      <ListField
        label='Medicação de uso contínuo'
        items={formatMedicationsList(form)}
      />
      <ReadOnlyField
        label='Faz acompanhamento psiquiátrico?'
        value={formatBoolean(form.has_psychiatrist_treatment)}
      />
      <ReadOnlyField
        label='De acordo com a sua avaliação, qual a motivação do paciente para seguir com o tratamento?'
        value={form.patient_goal && (PATIENT_GOAL_LABELS[form.patient_goal] ?? form.patient_goal)}
      />
      <ReadOnlyField
        label='De acordo com a sua avaliação, qual é a complexidade atual do caso?'
        value={
          form.patient_case_complexity
            ? PATIENT_CASE_COMPLEXITY_LABELS[form.patient_case_complexity] ?? form.patient_case_complexity
            : null
        }
        valueColor={
          form.patient_case_complexity
            ? PATIENT_CASE_COMPLEXITY_COLORS[form.patient_case_complexity]
            : undefined
        }
      />
      <ReadOnlyField
        label='Breve descrição e indicação clínica'
        value={form.patient_case_description}
      />
      <ListField
        label='Hipótese(s) diagnóstica(s) – CID'
        items={formatDiagnosticsList(form)}
      />
      <ReadOnlyField
        label='Encaminhamento a profissionais da saúde'
        value={form.referral_to_healthcare_professional}
      />
    </S.Section>
  )
}
